import React from 'react';

const MainContext = React.createContext({});

export default MainContext;
